// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0c0649c9","911":"3bd868e9"}[chunkId] + ".chunk.js";
};